export const generateInitialValues = () => {
  return {
    email: sessionStorage.getItem('email') ?? '',
    password: '',
    confirm: '',
  };
};
